import {
  CheckboxField,
  EditResourceForm,
  NumberField,
  ObjectField,
  processStateOptions,
  SelectField,
  TextField,
  WorkflowSelect,
} from "~/components/Form";
import { useIngestionPart, useUpdateIngestionPart } from "~/domain/datastores";
import { makeIngestionPartLocation, useIngestionPartParams } from "~/paths";
import { selectData } from "~/utils";
import {
  EDITABLE_INGESTION_PART_FIELDS,
  editIngestionPartSchema,
} from "../schemas";

export function IngestionPartEditForm() {
  const { ingestionId, ingestionPartId } = useIngestionPartParams();

  return (
    <EditResourceForm
      schema={editIngestionPartSchema}
      resourceName="ingestion part"
      query={useIngestionPart(ingestionId, ingestionPartId, {
        select: selectData,
      })}
      editableFields={EDITABLE_INGESTION_PART_FIELDS}
      mutation={useUpdateIngestionPart(ingestionId, ingestionPartId)}
      resourceLocation={makeIngestionPartLocation({
        ingestionPartId,
        ingestionId,
      })}
    >
      {(control) => (
        <>
          <NumberField control={control} name="sequence" required />
          <TextField control={control} name="source" />
          <SelectField
            control={control}
            name="state"
            options={processStateOptions}
            required
          />
          <NumberField control={control} name="progress" />
          <WorkflowSelect control={control} name="workflowId" />
          <ObjectField control={control} name="workflowContext" />
          <ObjectField control={control} name="error" />
          <CheckboxField control={control} name="locked" />
        </>
      )}
    </EditResourceForm>
  );
}
